export type UpgradeStatus = 'not_done' | 'done' | 'requested';

export interface AddressUpgradeAddress {
  id: number;
  address_name: string;
}

export interface AddressUpgrade {
  id: number;
  name: string;
  description: string;
  estimated_cost: number; // cents
  impact_score: 1 | 2 | 3;
  roi_score: number;
  status: UpgradeStatus;
  requested_at: string | null;
  address: AddressUpgradeAddress;
  created_at?: string;
  updated_at?: string;
}

export const UPGRADE_STATUS_OPTIONS: { value: UpgradeStatus; viewValue: string }[] = [
  { value: 'not_done', viewValue: 'Not Done' },
  { value: 'done', viewValue: 'Done' },
  { value: 'requested', viewValue: 'Ask TIDY' },
];

export const UPGRADE_IMPACT_OPTIONS: { value: 1 | 2 | 3; viewValue: string }[] = [
  { value: 1, viewValue: 'Low' },
  { value: 2, viewValue: 'Medium' },
  { value: 3, viewValue: 'High' },
];
